module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-rewards-32-active.ed927493.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-rewards-32-active.png
// module id = 3200
// module chunks = 11